import { useOptionDescription as useDescription } from "@/components/features/items/edit/option/_shared/ui/components/description/hooks/use-description";

import { useProductOptionFormModelContext } from "../../../../context";

export const useOptionDescription = () => {
	const { viewModel, onSetViewModel } = useProductOptionFormModelContext();
	const { description } = viewModel;

	return useDescription({ description, onSetViewModel });
};
